export default {
  login: {
    login: '登入',
    loginSubtitle: '登入你的帐号',
    username: '帐号',
    password: '密码',
    usernamePlaceholder:'用户名/电话号码/E-mail',
    forgetPassword: '忘记密码?'
  },
  register:{
    register:'注册',
    postfix:'请填写您的账号信息',
    telephone:'电话号码',
    confirmPassword:'确认密码',
    password:'密码',
    region:'注册地区',
    regionPlaceholder:'请选择地区',
    veriCodeHint:'发送及填写短信验证码',
    sendVeriCode:'发送验证码',
    smsVeriCode:'短信验证码',
    referralCodeHint:'填写介绍人推荐码',
    referralCode:'介绍人推荐码',
    sent:'已发送',
    actionFail:'操作未能完成',
    alertMsg:{
      required:'尚有资料未填写',
      registering:'验证中...',
      logining:'登入中...',
      regConfirmPrefix:'确认以',
      regConfirmPostfix:'作为你的登入账户？',
    },
     terms:{
      labelPrefix:'我已同意本網站的',
      privacy:'隱私條例',
      and:'及',
      userTerms:'用戶協議',
    }
  },
  forgetPassword: {
    forgetPassword: '重设密码',
    forgetPasswordSubtitle: '输入以下资料重设密码',
    username: '用户名称',
    backToLogin: '回去登入',
    success: '你的密码已被重设，即将于5秒内返回登入页面',
    oneTimePassword: '输入你的一次性密码',
    newPassword: '输入你的新密码',
    confirmNewPassword: '确认你的新密码',
    example: '例子: 12345678910 (手提电话号码)',
    advise: '你的密码长度应至小为8位，以及包含数字/大小写字母',
    notice: '你的一次性験证码已经发出，请在稍后时间检查你的信息',
    sendOneTimePassword: '发送一次性密码',
    countryCallingCode: '国际区号',
    fail: '你输入的资料不正确，请重新确认',
    sendOneTimePasswordAgain: '一次性密码再次发送于：',
    cooldown: '一次性密码冷却中，请稍后再试',
    choice: '请选择'
  }
}


// WEBPACK FOOTER //
// ./src/Auth/langs/zh_cn/index.js